const optionType = {
  TEXT: 'text',
  IMAGE: 'image',
  LISTENING: 'listening',
  LISTENING_AND_TEXT: 'listeningandtext',
  SAME_LISTENING: 'samelistening',
};
// eslint-disable-next-line
export default optionType;
